import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { Form, Modal, notification } from 'antd'
import { Formik } from 'formik'
import moment from 'moment'

import { getMessage } from '../../../../../../util/IntlMessages'
import { isAdmin } from '../../../../../../util/profiles'
import { actionStatus, actionStatusMap } from '../../constants'
import { useCreateActionContext } from '../../contexts/action'
import { useCreateActionMutation, useGetActionQuery, useUpdateActionMutation } from '../../services/action'

import './styles.less'

export function ActionForm({ children }) {
  const history = useHistory()

  const { actionId, isNewAction, setIsReadOnly, isPreview, setIsPreview, currentUser, validationSchema } =
    useCreateActionContext()

  const { data: actionData = { baseFields: {}, customFields: {} } } = useGetActionQuery(
    { actionId },
    { skip: isNewAction }
  )

  const [createAction] = useCreateActionMutation()
  const [updateAction] = useUpdateActionMutation()

  useEffect(
    function checkIsReadOnly() {
      if (!actionData?.baseFields?.actionStatusId) return
      const { baseFields } = actionData

      if (baseFields.actionStatusId === actionStatusMap.get(actionStatus.DONE) && !isAdmin(currentUser)) {
        setIsReadOnly(true)
      }
    },
    [actionData?.baseFields]
  )

  async function confirmAction(payload) {
    if (isNewAction) {
      const { data } = await createAction({ payload })
      if (data?.id) {
        history.push(`/actions/${payload.baseFields.actionTypeId}/${data.id}`)
      }
    } else {
      await updateAction({ actionId, payload })
    }
  }

  async function onSubmit({ baseFields, customFields }) {
    const payload = {
      customFields,
      baseFields: {
        ...baseFields,
        mobile: false,
        executionDate: baseFields?.executionDate ? moment(baseFields.executionDate).format('MM/DD/YYYY') : null,
        actionPlannedDoneTime: baseFields?.executionDate ? moment(baseFields.executionDate) : null
        /*
          [Suporte #46638] Visitas - Remover campo "Hora" do formulário principal
          USER STORY 10613 (AzureDevops)
        */
        // executionTime: baseFields?.executionTime ? moment(baseFields.executionTime, 'HH:mm').format('HH:mm') : null
      }
    }

    if (payload.baseFields?.finish && payload.baseFields.executionDate == null) {
      return notification.warn({
        description: getMessage('validationNotEmptyDateFinishActions'),
        message: getMessage('sweetAlerts.warning')
      })
    }

    if (payload.baseFields?.finish && moment(payload.baseFields.executionDate).isAfter(new Date())) {
      return notification.warn({
        description: getMessage('validationFutureDateFinishActions'),
        message: getMessage('sweetAlerts.attention')
      })
    }

    if (
      (payload.baseFields?.finish || payload.baseFields?.actionStatusId === actionStatusMap.get(actionStatus.DONE)) &&
      !isPreview
    ) {
      return setIsPreview(true)
    }

    if (payload.baseFields?.finish) {
      return Modal.confirm({
        title: getMessage('confirmActionFinish'),
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        icon: null,
        onOk: () => confirmAction(payload),
        onCancel: () => {}
      })
    }

    await confirmAction(payload)
  }

  return (
    <Formik
      enableReinitialize
      initialValues={actionData}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} layout="vertical" className="createActionForm">
          {children}
        </Form>
      )}
    </Formik>
  )
}
